// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  id: __t.string(),
  projectId: __t.string(),
  parentId: __t.option(__t.string()),
  body: __t.string(),
  timeUs: __t.option(__t.f64()),
  clipId: __t.option(__t.string()),
  endUs: __t.option(__t.f64()),
  drawing: __t.string(),
  versionId: __t.string(),
};
